interface Props {
  isDevelopment: boolean
}

export default function AdminIndex({ isDevelopment }: Props) {
  return (
    <div className="min-h-screen bg-stone-50 dark:bg-stone-950">
      <header className="bg-white dark:bg-stone-900 border-b border-stone-200 dark:border-stone-800">
        <div className="max-w-5xl mx-auto px-6 py-5">
          <h1 className="text-xl font-semibold text-stone-900 dark:text-stone-100">
            Admin
          </h1>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-6 py-6">
        <div className="bg-white dark:bg-stone-900 rounded-lg border border-stone-200 dark:border-stone-800 p-6">
          <ul className="space-y-4">
            {isDevelopment && (
              <li>
                <a
                  href="/letter_opener"
                  className="flex items-center gap-3 text-stone-900 dark:text-stone-100 hover:text-amber-600 dark:hover:text-amber-500"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  <span className="font-medium">Letter Opener</span>
                  <span className="text-sm text-stone-500 dark:text-stone-400">View test emails</span>
                </a>
              </li>
            )}
            <li>
              <a
                href="/admin/jobs"
                className="flex items-center gap-3 text-stone-900 dark:text-stone-100 hover:text-amber-600 dark:hover:text-amber-500"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
                </svg>
                <span className="font-medium">Background Jobs</span>
                <span className="text-sm text-stone-500 dark:text-stone-400">SolidQueue Mission Control</span>
              </a>
            </li>
          </ul>
        </div>
      </main>
    </div>
  )
}
